// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_page__sfREz {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Dashboard_topGrid__tmNPB {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  align-items: start;
}

.Dashboard_mainCol__Oby48,
.Dashboard_sideCol__uWTFF {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

/* Fila inferior a TODO el ancho: Office 1/3, Mode 2/3 */
.Dashboard_bottomRow__QYoCb {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
}

/* Botón Reset Data (inyectado al header) */
.Dashboard_resetBtn__P3Uhe {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1f1f1f;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 9px 18px;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.Dashboard_resetBtn__P3Uhe:hover {
  background: #000;
}

/* Estados */
.Dashboard_state__ZiTEU {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 400px;
  color: var(--dylo-muted);
  font-size: 14px;
}
.Dashboard_spinner__jMRKE {
  width: 40px;
  height: 40px;
  border: 3px solid var(--dylo-line);
  border-top-color: var(--dylo-teal-700);
  border-radius: 50%;
  animation: Dashboard_dash-spin__KVNcz 0.75s linear infinite;
}
@keyframes Dashboard_dash-spin__KVNcz {
  to { transform: rotate(360deg); }
}

/* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de lo que tenga dentro, y
   un texto que no se parte la ensancharía más que la pantalla (lo que le pasaba al login con sus campos). */
@media (max-width: 1100px) {
  .Dashboard_topGrid__tmNPB {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 620px) {
  .Dashboard_bottomRow__QYoCb {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;EAClB,2DAA0C;AAC5C;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;4GAC4G;AAC5G;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.topGrid {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  align-items: start;\n}\n\n.mainCol,\n.sideCol {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n/* Fila inferior a TODO el ancho: Office 1/3, Mode 2/3 */\n.bottomRow {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 16px;\n}\n\n/* Botón Reset Data (inyectado al header) */\n.resetBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1f1f1f;\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 9px 18px;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n.resetBtn:hover {\n  background: #000;\n}\n\n/* Estados */\n.state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-height: 400px;\n  color: var(--dylo-muted);\n  font-size: 14px;\n}\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--dylo-line);\n  border-top-color: var(--dylo-teal-700);\n  border-radius: 50%;\n  animation: dash-spin 0.75s linear infinite;\n}\n@keyframes dash-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de lo que tenga dentro, y\n   un texto que no se parte la ensancharía más que la pantalla (lo que le pasaba al login con sus campos). */\n@media (max-width: 1100px) {\n  .topGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 620px) {\n  .bottomRow {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Dashboard_page__sfREz`,
	"topGrid": `Dashboard_topGrid__tmNPB`,
	"mainCol": `Dashboard_mainCol__Oby48`,
	"sideCol": `Dashboard_sideCol__uWTFF`,
	"bottomRow": `Dashboard_bottomRow__QYoCb`,
	"resetBtn": `Dashboard_resetBtn__P3Uhe`,
	"state": `Dashboard_state__ZiTEU`,
	"spinner": `Dashboard_spinner__jMRKE`,
	"dash-spin": `Dashboard_dash-spin__KVNcz`
};
export default ___CSS_LOADER_EXPORT___;
